import { useEffect, useState } from "react";
import { Header } from "@/components/Header";
import { api } from "@/lib/api";
import { CategoryPills } from "@/components/CategoryPills";
import { OffersMap } from "@/components/OffersMap";
import { Loader2 } from "lucide-react";

export default function MapView() {
  const [services, setServices] = useState(null);
  const [categories, setCategories] = useState([]);
  const [active, setActive] = useState("alle");

  useEffect(() => { api.get("/categories").then((r) => setCategories(r.data)); }, []);
  useEffect(() => {
    const p = {};
    if (active !== "alle") p.category = active;
    api.get("/services", { params: p }).then((r) => setServices(r.data));
  }, [active]);

  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-8">
        <h1 className="font-heading text-3xl font-extrabold text-slate-900 mb-1">Angebote auf der Karte</h1>
        <p className="text-slate-500 mb-5">Filtere nach Kategorie oder finde Angebote im Umkreis deiner PLZ</p>
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-4 mb-5">
          <CategoryPills categories={categories} active={active} onChange={setActive} />
        </div>
        {services === null ? (
          <div className="flex justify-center py-24"><Loader2 className="w-8 h-8 animate-spin text-emerald-600" /></div>
        ) : (
          <OffersMap services={services} />
        )}
      </div>
    </div>
  );
}
